module.exports = __webpack_public_path__ + "img/grouphead1.2b9d473d.png";